import { AccountManagement } from "@/interfaces/accountManagement";
import accountServices from "@/services/account.services";
import find from "lodash/find";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import CreditCardsListComponent from "../AccountCreditCards/CreditCardList/CreditCardsList.component";
import Template from "./AutoBillConfigurationModal.template.vue";

@Component({
  mixins: [Template],
  components: {
    "cards-list": CreditCardsListComponent
  }
})
export default class AutoBillConfigurationModal extends Vue {
  @Prop({ default: null }) public nextPaymentDate!: string | null;
  @Getter("user", { namespace: "authModule" })
  public user!: any;
  public selectedCard: AccountManagement.CreditCard | null = null;
  public cards: AccountManagement.CreditCard[] = [];
  public loadingCards = false;

  public done() {
    this.$emit("resolve", this.selectedCard);
  }

  public selectCardAsAutoBillDefault($event: AccountManagement.CreditCard) {
    this.selectedCard = $event;
  }

  public close() {
    this.$emit("reject");
  }
  protected async mounted() {
    await this.loadCards();
    const findDef = find(this.cards, "default") as AccountManagement.CreditCard;
    this.selectedCard = findDef || null;
  }
  protected async loadCards() {
    this.loadingCards = true;
    this.cards = await accountServices.getCreditCards(
      this.user.settings.current_account_id
    );
    this.loadingCards = false;
  }
}
